export const COMMON_ACCOUNT_FEATURE = 'commonAccount';
export const COMMON_CART_FEATURE = 'commonCart';
export const COMMON_PRODUCT_FEATURE = 'commonProduct';
export const COMMON_ACCESSORY_FEATURE = 'commonAccessory';
export const COMMON_PRODUCT_COMPARATOR_FEATURE = 'commonProductComparator';
export const COMMON_CATEGORY_FEATURE = 'commonCategory';
export const COMMON_SEARCH_FEATURE = 'commonSearch';
export const COMMON_RECIPES_FEATURE = 'commonRecipes';
